<template>
    <div id="editable-grid-demo-container">
        <b-row>
            <b-col class="col-12 mt-2">
                <h4 class="page-title text-truncate">Editable Grid Component DEMO</h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="'Title'"
                    v-bind:Name="'gridTitle'"
                    v-bind:TypeProp="'text'"
                    v-model.number="gripProperties.title"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Show Add Button'"
                    v-bind:Name="'checkboxShowAdd'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="showAdd"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Show Delete Button'"
                    v-bind:Name="'checkboxShowDelete'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="showDelete"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Show Select All'"
                    v-bind:Name="'checkboxShowSelectAll'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="showSelectAll"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Show Search'"
                    v-bind:Name="'checkboxShowSearch'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="showSearch"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Selectable (no select-all bar)'"
                    v-bind:Name="'checkboxSelectable'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="selectable"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Multiple Selection'"
                    v-bind:Name="'checkboxMultiple'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="multiple"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Show Delete Action (per row)'"
                    v-bind:Name="'checkboxDelete-items'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="deleteActionButton.visible"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    v-bind:Label="'Show Print Action (per row)'"
                    v-bind:Name="'checkboxPrint-items'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="printActionButton.visible"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="'Time Format'"
                    v-bind:Options="timeFormatOptions"
                    v-bind:ModelArray="d_timeFormat"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'value'"
                    :Input="timeFormatChanged"
                    v-bind:Name="'time_format_dropdown'"
                    id="time_format_dropdown"
                />
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(action, index) in customActionButtons"
                :key="index"
            >
                <MdCheckBox
                    v-bind:Label="'Show Custom Action'"
                    v-bind:Name="'checkboxCustom-items'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="action.visible"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col class="col-12">
                <MdEditableGrid
                    :ref="'editableGrid'"
                    :columns="fields"
                    :rows="items"
                    :showMessageIsEmpty="showMessageIsEmpty"
                    :serverSidePagination="false"
                    :perPage="10"
                    :dataKey="dataKey"
                    :showAdd="showAdd"
                    :showDelete="showDelete"
                    :showSelectAll="showSelectAll"
                    :selectable="selectable"
                    :multiple="multiple"
                    :showSearch="showSearch"
                    :showBulkEdit="true"
                    :addActionButton="addActionButton"
                    :deleteActionButton="deleteActionButton"
                    :printActionButton="printActionButton"
                    :appendNewRows="appendNewRows"
                    :rowValidator="rowValidator"
                    :headerTitle="gripProperties.title"
                    :frozenColumnAction="true"
                    @cell-edit-complete="cellEditComplete"
                    @bulk-edit-complete="bulkEditComplete"
                    @cell-dbl-click="cellDoubleClick"
                    @cell-click="cellClick"
                    @cell-active="cellActivate"
                    @search="onSearch"
                ></MdEditableGrid>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="saveOrEdit"
                v-bind:isReadOnly="!pendingChanges || saving"
                v-bind:Name="'btn_save'"
            />
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage';
import validationRules from '@/common/validationRules';
import EnumService from '@/services/enum.service';

export default {
    name: 'EditableGridDemo',
    mixins: [ShowMessage],
    data() {
        return {
            timeFormat: '12h',
            timePrecision: 'mm',

            items: [
                {
                    recID: 1,
                    name: 'First Row',
                    integer: 0,
                    decimal: 5.34,
                    dropdown: 'Ordered',
                    lookup: 1,
                    lookupDescription: 'first',
                    date: null,
                    datetime: null,
                    time: null
                },
                {
                    recID: 2,
                    name: 'Second Row',
                    integer: 1,
                    decimal: -2.4,
                    dropdown: 'Fullygiven',
                    lookup: 2,
                    lookupDescription: 'second',
                    date: new Date(),
                    datetime: new Date(),
                    time: new Date()
                }
            ],
            showMessageIsEmpty: true,
            dataKey: 'recID',
            showAdd: true,
            showDelete: true,
            showSelectAll: true,
            selectable: false,
            multiple: true,
            showSearch: true,
            addActionButton: {
                handler: this.addItem
            },
            deleteActionButton: {
                visible: true,
                handler: this.deleteItem
            },
            printActionButton: {
                visible: true,
                handler: this.printItem
            },
            pendingChanges: false,
            saving: false,
            gripProperties: {
                title: ''
            },
            customActionButtons: [],
            d_timeFormat: {
                value: 'hhmmA',
                description: 'hh:mm A'
            },
            timeFormatOptions: [
                {
                    value: 'HHmm',
                    description: 'HH:mm'
                },
                {
                    value: 'HHmmss',
                    description: 'HH:mm:ss'
                },
                {
                    value: 'hhmmA',
                    description: 'hh:mm A'
                },
                {
                    value: 'hhmmssA',
                    description: 'hh:mm:ss A'
                }
            ]
        };
    },
    computed: {
        editableGrid() {
            return this.$refs.editableGrid;
        },
        fields() {
            return [
                {
                    key: 'name',
                    label: 'Text',
                    dataType: 'text',
                    editable: true,
                    focusable: true,
                    props: {
                        frozen: true
                    }
                },
                {
                    key: 'integer',
                    label: 'Integer',
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: 0,
                        inputType: 'integer'
                    }
                },
                {
                    key: 'decimal',
                    label: 'Decimal',
                    dataType: 'numeric',
                    editable: true,
                    focusable: true,
                    props: {
                        min: -5,
                        max: 5,
                        step: 0.1,
                        round: 1,
                        allowNegativeValue: true,
                        inputType: 'decimal'
                    }
                },
                {
                    key: 'dropdown',
                    label: 'Dropdown',
                    dataType: 'dropdown',
                    editable: true,
                    focusable: true,
                    props: {
                        options: EnumService.MedicationInboxSatusList,
                        optionKey: 'value',
                        optionValue: 'name'
                    }
                },
                {
                    key: 'lookup',
                    label: 'Lookup',
                    dataType: 'lookup',
                    editable: true,
                    focusable: true,
                    validator: [validationRules.required(this.$t('Msg.RequiredField'))],
                    props: {
                        api: 'Insurances',
                        searchTitle: this.$tc('Insurance.Insurance', 2),
                        fieldCode: 'insurancecode',
                        fieldDescription: 'company',
                        searchFieldCode: 'InsuranceCode',
                        valueDescription: 'lookupDescription',
                        fields: [
                            {
                                key: 'company',
                                sortable: true,
                                label: this.$t('insuranceSetup.CompanyName'),
                                class: 'text-rigth'
                            },
                            {
                                key: 'insurancecode',
                                sortable: true,
                                label: this.$t('Shared.InsuranceCode'),
                                class: 'text-rigth'
                            },
                            {
                                key: 'city',
                                sortable: true,
                                label: this.$t('Shared.City'),
                                class: 'text-rigth'
                            },
                            {
                                key: 'address1',
                                sortable: true,
                                label: this.$t('Shared.Address1'),
                                class: 'text-rigth'
                            },
                            {
                                key: 'address2',
                                sortable: true,
                                label: this.$t('Shared.Address2'),
                                class: 'text-rigth'
                            }
                        ]
                    }
                },
                {
                    key: 'date',
                    label: 'Date',
                    dataType: 'date',
                    editable: true,
                    focusable: true
                },
                {
                    key: 'datetime',
                    label: 'DateTime',
                    dataType: 'datetime',
                    editable: true,
                    focusable: true,
                    props: {
                        timeFormat: this.timeFormat,
                        precision: this.timePrecision
                    }
                },
                {
                    key: 'time',
                    label: 'Time',
                    dataType: 'time',
                    editable: true,
                    focusable: true,
                    props: {
                        timeFormat: this.timeFormat,
                        precision: this.timePrecision
                    }
                }
            ];
        }
    },
    methods: {
        indexOfFromItemRowKey(rowKey) {
            return this.items.findIndex(x => x[this.dataKey] === rowKey);
        },

        cellEditComplete({ rowKey, columnKey, value, lookupInfo }) {
            const rowIndex = this.indexOfFromItemRowKey(rowKey);
            console.log('cellEditComplete', rowKey, columnKey, value, lookupInfo, rowIndex);

            if (rowIndex !== -1) {
                console.log(JSON.stringify(this.items[rowIndex]));
                this.items[rowIndex][columnKey] = value;
                if (columnKey === 'lookup' && lookupInfo) {
                    this.items[rowIndex].lookupDescription = lookupInfo.description;
                }
                console.log(JSON.stringify(this.items[rowIndex]));
                this.pendingChanges = true;
            }
        },

        bulkEditComplete({ rows, editedValues }) {
            rows.forEach(row => {
                const item = this.items.find(i => i[this.dataKey] === row[this.dataKey]);
                if (item) {
                    Object.entries(editedValues).forEach(([key, val]) => {
                        if (val !== null && val !== undefined) {
                            this.$set(item, key, val);
                        }
                    });
                }
            });
            this.pendingChanges = true;
        },

        cellDoubleClick() {},
        cellClick() {},
        cellActivate() {},

        onSearch(text) {
            console.log('onSearch', text);
        },

        addItem() {
            console.log('add');
            this.pendingChanges = true;
        },

        deleteItem(item) {
            // Called with a single row from the inline per-row delete icon,
            // or with the full array of selected rows from the toolbar's bulk Delete button.
            const rows = Array.isArray(item) ? item : [item];
            console.log('deleteItem', rows);
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteAllRecord'), {
                    title: this.$tc('Shared.DelRecord', rows.length),
                    okTitle: this.$t('Shared.TitleDeleteAll'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        rows.forEach(row => {
                            const rowIndex = this.indexOfFromItemRowKey(row.recID);
                            if (rowIndex !== -1) {
                                this.items.splice(rowIndex, 1);
                            }
                        });
                        this.pendingChanges = true;
                    }
                });
        },

        printItem(item) {
            console.log('printItem', item);
            this.pendingChanges = true;
        },

        //Devuelve true o false si se adiciono la fila
        appendNewRows(rows) {
            console.log('appendNewRows', rows);

            let newKey = this.items.length + 1;
            rows.forEach(row => {
                this.items.push({ recID: newKey++, ...row });
            });
            this.pendingChanges = true;
            return true;
        },

        //Devuelve un arreglo con el nombre de las columna que no seon validas
        rowValidator(row) {
            const result = [];

            //HACER validacion de la fila
            if (row.integer != null && row.integer > 5) {
                result.push('integer');
            }

            return result;
        },

        async saveOrEdit() {
            this.saving = true;
            if (await this.editableGrid.save()) {
                this.pendingChanges = false;

                setTimeout(
                    () =>
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        }),
                    50
                );
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.InvalidFieldValuesDetected'),
                    'errorAutoHide'
                );
            }
            this.saving = false;
        },

        timeFormatChanged(value) {
            this.$nextTick(() => {
                if (value) {
                    switch (value.value) {
                        case 'HHmm':
                            this.timeFormat = '24h';
                            this.timePrecision = 'mm';
                            break;
                        case 'HHmmss':
                            this.timeFormat = '24h';
                            this.timePrecision = 'mm:ss';
                            break;
                        case 'hhmmA':
                            this.timeFormat = '12h';
                            this.timePrecision = 'mm';
                            break;
                        case 'hhmmssA':
                            this.timeFormat = '12h';
                            this.timePrecision = 'mm:ss';
                            break;
                        default:
                            this.timeFormat = '12h';
                            this.timePrecision = 'mm';
                    }
                } else {
                    this.timeFormat = '12h';
                    this.timePrecision = 'mm';
                }
            });
        }
    }
};
</script>
